export default "__VITE_ASSET__CnZVJ07x__"